import type { JSX } from 'react'
import { ParticipantPageLayout } from '#src/components/patient/page/ParticipantPageLayout.tsx'
import { useCurrentParticipant } from '#src/contexts/current-participant/useCurrentParticipant.ts'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'
import { useMyTasksCount } from '#src/hooks/useMyTasksCount.ts'
import { usePatientNavigationItems } from '#src/hooks/usePatientNavigationItems.ts'

export function PatientShell(): JSX.Element {
  const participant = useCurrentParticipant()
  const currentPractitioner = useCurrentPractitioner()
  const { count: myTasksCount } = useMyTasksCount(
    participant?.reference,
    currentPractitioner.reference
  )

  const navigationItems = usePatientNavigationItems({
    tasksIndicator: myTasksCount,
  })

  return (
    <ParticipantPageLayout
      participant={participant}
      navigationItems={navigationItems}
    />
  )
}
